import { Component } from '@angular/core';

@Component({
  selector: 'app-quality-management',
  templateUrl: './quality-management.component.html',
  styleUrl: './quality-management.component.scss'
})
export class QualityManagementComponent {

}
